import React from "react";
import {
    Grid,
    Typography,
    Box,
} from "@mui/material";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { NonFaceProductsProps } from "../../../interfaces/productVariationInterface";
import Utility from "../../../utils/Utility";
import Skeleton from "../../common/Skeleton";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import ImageIcon from "@mui/icons-material/Image";

const NonFaceProducts = (props:NonFaceProductsProps) => {
    const { variationDetailData , index, nonFaceProductSkeleton} = props;
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;
    const isSuperAdminDemoSeller = useAppSelector((state) => state.common.superAdminDemoSeller) ?? false;
    /**
            *
            * @description - Make Product name linkable to order list page
            */ 
    const productNameLink = (name: any, id: any,isDemoUser:boolean,isSuperAdminDemoSeller:boolean) => {
        return (
            (isDemoUser || isSuperAdminDemoSeller) ? name : (<Link to={`${process.env.REACT_APP_PRODUCT_BASE_URL}/${id}.html`} target="_blank" rel="noopener noreferrer" className="Order_id_link">
                {name}
            </Link>)
        );
    };
    return (
        <>
            {
                nonFaceProductSkeleton ? (
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={60}
                        count={1}
                        my={1}
                    />
                ) : (
                    variationDetailData.length > 0 ?
                        variationDetailData?.map((childData) => {
                            return (
                                <Grid key={index} alignItems="center" sx={{ paddingY: 1 }}>
                                    <Grid container spacing={2} className="word_wrap_class word_break_all" alignItems="center"  xs={12} sm={12} md={11.81} lg={11.76}>
                                        <Grid item xs={12} sm={12} md={0.5} lg={0.5} >
                                            <Typography><ArrowRightIcon /></Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1} lg={1.03}>
                                            {childData?.featuredImage != "" ?
                                                <Box
                                                    sx={{
                                                        width: 55,
                                                        height: 55,
                                                    }}
                                            
                                                >
                                                    <img
                                                        src={(isDemoUser || isSuperAdminDemoSeller) ? `${childData?.featuredImage}` : `${childData?.featuredImage}?date=${new Utility().dateTimeCache()}`}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </Box>:
                                                <ImageIcon className="featuredImage" />
                                            }  
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.2} lg={1.2}>
                                            <Typography>{childData?.productCode}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.5} lg={1.5}>
                                            <Typography>{childData?.cainzProductCode}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2.8} lg={2.8} >
                                            <Typography>{ productNameLink(childData?.productName,childData?.cainzProductCode,isDemoUser,isSuperAdminDemoSeller)}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1} lg={1}>
                                            <Typography>{childData?.publicFlag==0?t("product_variation_list.private"):t("product_variation_list.public")}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })
                        :
                        <Box sx={{backgroundColor:"#F5F5F5" }}>
                            <Typography  align="center" variant="body2">{t("product_variation_list.no_data_found")}</Typography>
                        </Box>
                )
            }
        </>
    );
};

export default NonFaceProducts;

